import { render } from "./IntercomDisconnectConfirm.vue?vue&type=template&id=87bbb3a4&scoped=true"
import script from "./IntercomDisconnectConfirm.vue?vue&type=script&lang=js"
export * from "./IntercomDisconnectConfirm.vue?vue&type=script&lang=js"

import "./IntercomDisconnectConfirm.vue?vue&type=style&index=0&id=87bbb3a4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87bbb3a4"],['__file',"src/assets/js/pages/Popup/IntercomDisconnectConfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87bbb3a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87bbb3a4', __exports__)) {
    api.reload('87bbb3a4', __exports__)
  }
  
  module.hot.accept("./IntercomDisconnectConfirm.vue?vue&type=template&id=87bbb3a4&scoped=true", () => {
    api.rerender('87bbb3a4', render)
  })

}


export default __exports__